import Backbone from 'backbone';



const Folder = Backbone.Model.extend({

  urlRoot: '/api/page_folders'

  
});


export default Folder;